module.exports = __webpack_public_path__ + "img/11_newYouth_lm.f3d81d34.png";